import { ProviderActivationEventName } from '@uplift/api';
import { useCurrentuser } from '@uplift/contexts';
import { useProviderActivationEvents } from '@uplift/queries';

export const useCanAccessPracticeStates = () => {
  const me = useCurrentuser();
  const { data: events, isInitialLoading } = useProviderActivationEvents(me?.id);
  const isCredentialingApproved = events?.some(event => event.eventName === ProviderActivationEventName.credentialingApproved);

  return { canAccess: isCredentialingApproved, isLoading: isInitialLoading };
};
